import { noop } from '@src/utils';
import { type DependencyList, useEffect, useRef } from 'react';

function useUpdateEffect(
  callback: () => void,
  deps: DependencyList = [],
  clear: () => void = noop,
) {
  const counterRef = useRef(0);
  const callbackRef = useRef(callback);
  const clearRef = useRef(clear);
  callbackRef.current = callback;
  clearRef.current = clear;

  useEffect(() => {
    counterRef.current += 1;
    if (counterRef.current <= 1) {
      return;
    }
    callbackRef.current();
    return () => {
      clearRef.current();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps]);
}

export default useUpdateEffect;
